<template lang="pug">
	.card-body
		.row
			.col-sm-5
				.form-group
					label Forma de pago habitual
					select.form-control(v-model="cliente.facturacion.forma_de_pago_ID", :disabled="!permisoEditar")
						option(:value="null") Selecciona
						option(v-for="forma in formasPago" :key="forma.ID" :value="forma.ID") {{forma.nombre}}
				div.form-group(style="display:none;")
					label Día de cobro
					select.form-control(v-model="cliente.facturacion.dia_cobro")
						option(:value="null")
						option(:value="index + 1" v-for="(dia, index) in new Array(31)" :key="dia") {{(index + 1)}}
			.col-sm-2(style="text-align:center;")
				.form-group(v-if="cliente.facturacion.forma_de_pago_ID")
					label Tipo de cuenta
					br
					.btn-group
						button.btn.btn-sm(:class="(cliente.facturacion.tipoCuenta === 'cc') ? 'btn-primary' : 'btn-default'" @click="setTipoCuenta('cc')", :disabled="!permisoEditar")
							| C.C.
						button.btn.btn-sm(:class="(cliente.facturacion.tipoCuenta === 'iban') ? 'btn-primary' : 'btn-default'" @click="setTipoCuenta('iban')", :disabled="!permisoEditar")
							| IBAN
			div.col-sm-5
				div.form-group(v-if="cliente.facturacion.tipoCuenta && cliente.facturacion.forma_de_pago_ID")
					label Nº de cuenta
					input.form-control(type="text" :disabled="!cliente.facturacion.tipoCuenta || !permisoEditar" v-model="cliente.facturacion.cuenta" v-mask="mascaras[cliente.facturacion.tipoCuenta]")
</template>

<script>
export default {
	props: ['cliente', 'formasPago', 'permisoEditar'],
	data () {
		return {
			mascaras: {
				cc: '#### #### ## ##########',
				iban: 'AA## #### #### #### #### ####'
			}
		}
	},
	methods: {
		setTipoCuenta (tipo) {
			this.cliente.facturacion.tipoCuenta = tipo
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-clientes/vue/components/editor/datos-facturacion.vue